import { API_BASE_URL } from "./apiClient";
import { clientPortalRequest } from "./clientPortalFetch";

async function clientFetch(path, options = {}) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(body.message || "Request failed");
  }
  return body;
}

export function clientLogin(email, password) {
  return clientFetch("/api/client/auth/login", {
    method: "POST",
    body: JSON.stringify({ email, password }),
  });
}

export function clientLogout() {
  return clientFetch("/api/client/auth/logout", { method: "POST" });
}

export function getClientMe() {
  return clientFetch("/api/client/me");
}

export function changeClientPassword({ currentPassword, newPassword }) {
  return clientPortalRequest("/change-password", {
    method: "POST",
    body: JSON.stringify({ currentPassword, newPassword }),
  });
}
